import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { XCircle, Home, RotateCcw } from 'lucide-react';

export const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="max-w-lg w-full">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center">
              <XCircle className="w-12 h-12 text-orange-600" />
            </div>
          </div>
          <CardTitle className="text-2xl text-orange-600">
            Paiement Annulé
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-6">
          <div>
            <p className="text-gray-600 mb-2">
              Votre paiement a été annulé.
            </p>
            <p className="text-gray-600">
              Aucun montant n'a été débité de votre compte. Vous pouvez réessayer à tout moment.
            </p>
          </div>

          <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
            <h3 className="font-semibold text-gray-900 mb-2">Besoin d'aide ?</h3>
            <p className="text-sm text-gray-600">
              Si vous rencontrez des difficultés pour effectuer le paiement, n'hésitez pas à nous contacter.
              Notre équipe est à votre disposition pour vous assister.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => window.history.back()}
              className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black font-semibold"
            >
              <RotateCcw className="w-4 h-4 mr-2" />
              Réessayer le paiement
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/')}
            >
              <Home className="w-4 h-4 mr-2" />
              Retour à l'accueil
            </Button>
          </div>

          <div className="pt-6 border-t">
            <p className="text-sm text-gray-500">
              <strong>Contact Z&N Solar</strong>
              <br />
              📞 06 23 73 77 80 | ✉️ contact@znsolar.fr
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
